import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../ui/EmptyState';

interface Props {
  tab: 'active' | 'history';
}

export const EmptyBookings: React.FC<Props> = ({ tab }) => {
  const navigate = useNavigate();

  if (tab === 'active') {
    return (
      <EmptyState
        title="Faol bronlar yo'q"
        description="Yangi tashrifni hozir bron qilishingiz mumkin"
        action={{ label: 'Bron qilish', onClick: () => navigate('/booking/new/0') }}
      />
    );
  }

  return (
    <EmptyState
      title="Tarix hali yo'q"
      description="Oldingi tashriflaringiz shu yerda ko'rinadi"
    />
  );
};
